import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { userloginDetails } from "../Utils/AdminAuth";
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";
import Spining from "../UI/Spining/Spining";

const UserBillingMode = (props) => {
  const lStorage = userloginDetails();
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const empType = lStorage.user.isAdmin;
  const permissionsubadmin = lStorage?.permission?.per_value?.usermanagement?.children
  const { id, userType } = useParams();
  const param = useParams();

  const [email, setEmail] = useState("");
  const [smsType, setSmsType] = useState("smssubmission");
  const [whatsappType, setWhatsappType] = useState("whatsappsubmission");
  const [emailType, setEmailType] = useState("emailsubmission");
  const [voiceType, setVoiceType] = useState("voicesubmission");
  const [rcsType, setRcsType] = useState("rcssubmission");
  const [agent, setAgent] = useState("");
  const [perAgentCost, setPerAgentCost] = useState(1500);
  const [selectAgent, setSelectAgent] = useState(10);
  const [perConversationCost, setPerConversationCost] = useState(10000);
  const [exceedLimitCost, setExceedLimitCost] = useState(0.15);
  const [refund, setRefund] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState({
    errorStatus: false,
    bgColor: "",
    errorMessage: "",
  });
  const [dltScrubbingCharge, setDltScrubbingCharge] = useState({
    sms: 0.0295,
    whatsapp: 0,
    rcs: 0,
    email: 0,
    voice: 0
  })

  useEffect(() => {
    getUserDetails();
    BillingModeList();
  }, []);



  const getUserDetails = async () => {
    try {
      const response = await fetch(`${HOST_URL}/admin_user_list.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: userId,
          method: "retrieve",
          type: "userdetails",
          ret_user_id: id,
          token: userToken,
        }),
      });

      const result = await response.json();

      if (result.success === true) {
        setEmail(result.data[0].email);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };


  const handleSmsTypeChange = (e) => {
    const { value } = e.target;
    if (smsType !== value) {
      setSmsType(value);
    } else {
      setSmsType("");
    }
    setError({ errorStatus: false });
  };

  const handleWhatsappTypeChange = (e) => {
    const { value } = e.target;
    if (whatsappType !== value) {
      setWhatsappType(value);
    } else {
      setWhatsappType("");
    }
    setError({ errorStatus: false });
  };

  const handleEmailTypeChange = (e) => {
    const { value } = e.target;
    if (whatsappType !== value) {
      setEmailType(value);
    } else {
      setEmailType("");
    }
    setError({ errorStatus: false });
  };

  const handleVoiceTypeChange = (e) => {
    const { value } = e.target;
    if (whatsappType !== value) {
      setVoiceType(value);
    } else {
      setVoiceType("");
    }
    setError({ errorStatus: false });
  };

  const handleRcsTypeChange = (e) => {
    const { value } = e.target;
    if (whatsappType !== value) {
      setRcsType(value);
    } else {
      setRcsType("");
    }
    setError({ errorStatus: false });
  };

  const handleAgentTypeChange = (e) => {
    const { value } = e.target;
    if (whatsappType !== value) {
      setAgent(value);
    } else {
      setAgent("");
    }
    setError({ errorStatus: false });
  };

  const handleRefundChange = (e) => {
    const { value } = e.target;
    if (refund !== value) {
      setRefund(value);
    } else {
      setRefund("");
    }
    setError({ errorStatus: false });
  };

  const isValid = () => {
    if (smsType === "" || smsType === undefined) {
      setError({
        errorStatus: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please select SMS",
      });
      return false;
    }

    if (whatsappType === "" || whatsappType === undefined) {
      setError({
        errorStatus: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please select Whatsapp",
      });
      return false;
    }
    if (emailType === "" || emailType === undefined) {
      setError({
        errorStatus: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please select Email",
      });
      return false;
    }
    if (voiceType === "" || voiceType === undefined) {
      setError({
        errorStatus: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please select Voice",
      });
      return false;
    }
    if (rcsType === "" || rcsType === undefined) {
      setError({
        errorStatus: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please select RCS",
      });
      return false;
    }
    if (agent === "" || agent === undefined) {
      setError({
        errorStatus: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please select Agent",
      });
      return false;
    }

    if (agent === "peragent") {
      if (perAgentCost === "" || perAgentCost === undefined) {
        setError({
          errorStatus: true,
          bgColor: "alert alert-danger alert-dismissible",
          errorMessage: "Please Enter Per Agent Cost",
        });
        return false;
      }
    }

    if (perConversationCost === "" || perConversationCost === undefined) {
      setError({
        errorStatus: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please Enter Per Conversation Cost",
      });
      return false;
    }

    if (refund === "" || refund === undefined) {
      setError({
        errorStatus: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: "Please select Auto Refund",
      });
      return false;
    }

    // if (dltScrubbingCharge.sms === 0) {
    //   setError({
    //     errorStatus: true,
    //     bgColor: "alert alert-danger alert-dismissible",
    //     errorMessage: "Please Enter SMS Price",
    //   });
    //   return false;
    // }

    // if (dltScrubbingCharge.whatsapp === 0) {
    //   setError({
    //     errorStatus: true,
    //     bgColor: "alert alert-danger alert-dismissible",
    //     errorMessage: "Please Enter Whatsapp Price",
    //   });
    //   return false;
    // }

    // if (dltScrubbingCharge.rcs === 0) {
    //   setError({
    //     errorStatus: true,
    //     bgColor: "alert alert-danger alert-dismissible",
    //     errorMessage: "Please Enter RCS Price",
    //   });
    //   return false;
    // }

    // if (dltScrubbingCharge.email === 0) {
    //   setError({
    //     errorStatus: true,
    //     bgColor: "alert alert-danger alert-dismissible",
    //     errorMessage: "Please Enter Email Price",
    //   });
    //   return false;
    // }

    // if (dltScrubbingCharge.voice === 0) {
    //   setError({
    //     errorStatus: true,
    //     bgColor: "alert alert-danger alert-dismissible",
    //     errorMessage: "Please Enter Voice Price",
    //   });
    //   return false;
    // }

    return true;
  };

  const SubmitBillingMode = async () => {
    if (isValid()) {
      let param = {
        user_id: userId,
        token: userToken,
        allow_agents: selectAgent,
        per_agent: perAgentCost ? perAgentCost : 0,
        voice_submission: voiceType === "voiceSubmission" ? 0 : 1,
        auto_refund: refund === "yes" ? 1 : 0,
        per_agent_conv: perConversationCost ? perConversationCost : 0,
        whatsapp_deliver: whatsappType === "whatsappDeliver" ? 1 : 0,
        retr_user_id: id,
        sms_deliver: smsType === "smsDeliver" ? 1 : 0,
        method: "billingmodel",
        email_deliver: emailType === "emailDeliver" ? 1 : 0,
        rcs_deliver: rcsType === "rcsDeliver" ? 1 : 0,
        per_agent_module: agent === "peragent" ? "per_agent" : "per_conv",
        exceed_price: exceedLimitCost,
        dltScrubbingCharge: { sms: dltScrubbingCharge.sms, voice: dltScrubbingCharge.voice, rcs: dltScrubbingCharge.rcs, whatsapp: dltScrubbingCharge.whatsapp, email: dltScrubbingCharge.email }
      };
      try {
        let { data } = await Axios.post(
          `${NODE_HOST_URL_v1}/billingModel`,
          param
        );
        if (data.success) {
          setError({
            errorStatus: true,
            bgColor: "alert alert-success alert-dismissible",
            errorMessage: data.message,
          });

          setTimeout(() => {
            setError({ errorStatus: false });
          }, 3000);
        } else {
          setError({
            errorStatus: true,
            bgColor: "alert alert-danger alert-dismissible",
            errorMessage: data.message,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const BillingModeList = async () => {
    let paramdata = {
      user_id: userId,
      token: userToken,
      retr_user_id: id,
      method: "list_model",
    };
    try {
      let { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/billingModel`,
        paramdata
      );
      if (data.success) {
        let dltScrubbingCharge = JSON?.parse(data.data[0].dlt_scrub_charges);
        let sms = data.data[0].sms === 1 ? "smsDeliver" : "smsSubmission";
        let whatsapp =
          data.data[0].whatsapp === 1
            ? "whatsappDeliver"
            : "whatsappSubmission";
        let email =
          data.data[0].email === 1 ? "emailDeliver" : "emailSubmission";
        let voice =
          data.data[0].voice === 1 ? "voiceDeliver" : "voiceSubmission";
        let rcs = data.data[0].rcs === 1 ? "rcsDeliver" : "rcsSubmission";
        let agentModule =
          data.data[0].agent_module === "per_conv"
            ? "perconversation"
            : "peragent";
        let autoRefund = data.data[0].auto_refund === 1 ? "yes" : "no";

        setSmsType(sms);
        setWhatsappType(whatsapp);
        setEmailType(email);
        setVoiceType(voice);
        setRcsType(rcs);
        setAgent(agentModule);
        setPerAgentCost(data.data[0].per_agent_price);
        setPerConversationCost(
          agentModule === "perconversation"
            ? data.data[0].per_conv_price
            : data.data[0].conv_limit
        );
        setRefund(autoRefund);
        setExceedLimitCost(data.data[0].limit_exceed_price);
        setDltScrubbingCharge({
          sms: dltScrubbingCharge.sms,
          whatsapp: dltScrubbingCharge.whatsapp,
          rcs: dltScrubbingCharge.rcs,
          email: dltScrubbingCharge.email,
          voice: dltScrubbingCharge.voice
        })
        setSelectAgent(data.data[0].allow_agents)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDltScrubbingChange = (e) => {
    setDltScrubbingCharge({ ...dltScrubbingCharge, [e.target.name]: e.target.value });
    setError({ errorStatus: false });
  }

  return (
    <div>
      <div className="wrapper">
        {isLoading && <Spining />}
        <AdminLeftMenu />
        <div className="main">
          <AdminHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className="row mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    User Details{" "}
                    <strong className="text-info"> {email} </strong>{" "}
                  </h3>
                </div>
              </div>
              <div className="row">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <div >
                        <nav className="text-center" aria-label="breadcrumb">
                          <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                            <Link
                              to={"/admin/user-details/" + id + `/` + userType}
                            >
                              <li className="breadcrumb-item">
                                User Details{" "}
                              </li>{" "}
                            </Link>

                            {(empType === "admin" || empType === "reseller" || empType === "emp" || (empType === "subadmin" && permissionsubadmin.transactiondetails)) &&
                              <Link
                                to={
                                  "/admin/user-transaction-details/" +
                                  id +
                                  `/` +
                                  userType
                                }
                              >
                                <li className="breadcrumb-item">
                                  {" "}
                                  Transaction Details{" "}
                                </li>
                              </Link>}

                            {(empType === "admin" || empType === "reseller" || empType === "emp" || (empType === "subadmin" && permissionsubadmin.addeditprice)) &&
                              <Link
                                to={
                                  "/admin/user-price-details/" +
                                  id +
                                  `/` +
                                  userType + `?` + "channel=whatsapp"
                                }
                              >
                                <li className="breadcrumb-item"> Add Price </li>
                              </Link>}

                            {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.awssettings)) && (
                              <Link
                                to={
                                  "/admin/aws-settings/" +
                                  id +
                                  `/` +
                                  userType + `?` + "channel=whatsapp"
                                }
                              >
                                <li className="breadcrumb-item"> AWS Settings </li>
                              </Link>
                            )}
                            {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.billingmode)) && (
                              <Link
                                to={
                                  "/admin/user-billing-mode/" +
                                  id +
                                  `/` +
                                  userType
                                }
                              >
                                {" "}
                                <li className="breadcrumb-item active">
                                  {" "}
                                  Billing Mode{" "}
                                </li>
                              </Link>
                            )}

                            {userType === "reseller" ? null : (
                              <>
                                {(empType === "admin" || empType === "emp" || (empType === "subadmin" && permissionsubadmin.addeditcredit)) &&
                                  <Link
                                    to={
                                      "/admin/user-add-price/" +
                                      id +
                                      `/` +
                                      userType
                                    }
                                  >
                                    {" "}
                                    <li className="breadcrumb-item">
                                      {" "}
                                      Add Credit{" "}
                                    </li>
                                  </Link>}

                                {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.entitybypass)) &&
                                  <Link
                                    to={
                                      "/admin/user-entity-pass/" +
                                      id +
                                      `/` +
                                      userType
                                    }
                                  >
                                    {" "}
                                    <li className="breadcrumb-item">
                                      {" "}
                                      Entity By Pass{" "}
                                    </li>
                                  </Link>}

                                {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.changecurrency)) &&
                                  <Link
                                    to={
                                      "/admin/change-currency/" +
                                      id +
                                      `/` +
                                      userType
                                    }
                                  >
                                    {" "}
                                    <li className="breadcrumb-item ">
                                      {" "}
                                      Change Currency{" "}
                                    </li>
                                  </Link>}

                                {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.bulksmsroutesetting)) &&
                                  <Link
                                    to={
                                      "/admin/bulk-sms-route/" +
                                      id +
                                      `/` +
                                      userType
                                    }
                                  >
                                    {" "}
                                    <li className="breadcrumb-item ">
                                      {" "}
                                      Bulk Sms Route Setting{" "}
                                    </li>
                                  </Link>}

                                {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.autoshorturl)) &&
                                  <Link
                                    to={`/admin/api-auto-short-url/${id}/${userType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Auto Short URL
                                    </li>
                                  </Link>}

                                {/* {empType === "admin" &&
                                  <Link
                                    to={`/admin/extra-settings/${id}/${userType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Extra Settings
                                    </li>
                                  </Link>} */}
                                {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.extrasettings)) &&
                                  <Link
                                    to={`/admin/extra-settings/${id}/${userType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Extra Settings
                                    </li>
                                  </Link>}

                                {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.mmlite)) &&
                                  <Link
                                    to={`/admin/mmlite/${id}/${userType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      MMLite
                                    </li>
                                  </Link>}
                                {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.ai_bot)) &&
                                  <Link
                                    to={`/admin/ai-bot/${id}/${userType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      AI Bot
                                    </li>
                                  </Link>}

                                {(empType === "admin" || (empType === "subadmin" && permissionsubadmin.edituserplan)) &&
                                  <Link
                                    to={`/admin/edit-user-plan/${id}/${userType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      Edit User Plan
                                    </li>
                                  </Link>}
                                {/* {empType === "admin" &&
                                  <Link
                                    to={`/admin/ivr-setting/${id}/${userType}`}
                                  >
                                    <li className="breadcrumb-item">
                                      IVR Setting
                                    </li>
                                  </Link>} */}
                              </>
                            )}
                          </ol>
                        </nav>
                      </div>
                    </h5>
                  </div>

                  <div className="card-body">
                    {error.errorStatus && (
                      <div className={`alert ${error.bgColor}`} role="alert">
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                        <div>{error.errorMessage}</div>
                      </div>
                    )}

                    <div className="filter-option">
                      <div className="card">
                        <h5 className="ml-3 mt-3">Channels</h5>

                        {/* SMS */}
                        <div className="row mb-3">
                          <div className="col-md-3 col-sm-12">
                            <h6 className="ml-3">SMS</h6>
                          </div>
                          <div className="col-md-9 col-sm-12">
                            <div className="d-flex flex-wrap">
                              <div className="form-check mr-4">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="sms-Deliver"
                                  checked={smsType === "smsDeliver"}
                                  onChange={handleSmsTypeChange}
                                  value="smsDeliver"
                                />
                                <label className="form-check-label" htmlFor="sms-Deliver">Deliver</label>
                              </div>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="sms-submission"
                                  checked={smsType === "smsSubmission"}
                                  onChange={handleSmsTypeChange}
                                  value="smsSubmission"
                                />
                                <label className="form-check-label" htmlFor="sms-submission">Submission</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Whatsapp */}
                        <div className="row mb-3">
                          <div className="col-md-3 col-sm-12">
                            <h6 className="ml-3">Whatsapp</h6>
                          </div>
                          <div className="col-md-9 col-sm-12">
                            <div className="d-flex flex-wrap">
                              <div className="form-check mr-4">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="whatsapp-Deliver"
                                  checked={whatsappType === "whatsappDeliver"}
                                  onChange={handleWhatsappTypeChange}
                                  value="whatsappDeliver"
                                />
                                <label className="form-check-label" htmlFor="whatsapp-Deliver">Deliver</label>
                              </div>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="whatsapp-submission"
                                  checked={whatsappType === "whatsappSubmission"}
                                  onChange={handleWhatsappTypeChange}
                                  value="whatsappSubmission"
                                />
                                <label className="form-check-label" htmlFor="whatsapp-submission">Submission</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Email */}
                        <div className="row mb-3">
                          <div className="col-md-3 col-sm-12">
                            <h6 className="ml-3">Email</h6>
                          </div>
                          <div className="col-md-9 col-sm-12">
                            <div className="d-flex flex-wrap">
                              <div className="form-check mr-4">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="email-Deliver"
                                  checked={emailType === "emailDeliver"}
                                  onChange={handleEmailTypeChange}
                                  value="emailDeliver"
                                />
                                <label className="form-check-label" htmlFor="email-Deliver">Deliver</label>
                              </div>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="email-submission"
                                  checked={emailType === "emailSubmission"}
                                  onChange={handleEmailTypeChange}
                                  value="emailSubmission"
                                />
                                <label className="form-check-label" htmlFor="email-submission">Submission</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Voice */}
                        <div className="row mb-3">
                          <div className="col-md-3 col-sm-12">
                            <h6 className="ml-3">Voice</h6>
                          </div>
                          <div className="col-md-9 col-sm-12">
                            <div className="d-flex flex-wrap">
                              <div className="form-check mr-4">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="voice-Deliver"
                                  checked={voiceType === "voiceDeliver"}
                                  onChange={handleVoiceTypeChange}
                                  value="voiceDeliver"
                                />
                                <label className="form-check-label" htmlFor="voice-Deliver">Deliver</label>
                              </div>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="voice-submission"
                                  checked={voiceType === "voiceSubmission"}
                                  onChange={handleVoiceTypeChange}
                                  value="voiceSubmission"
                                />
                                <label className="form-check-label" htmlFor="voice-submission">Submission</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* RCS */}
                        <div className="row mb-3">
                          <div className="col-md-3 col-sm-12">
                            <h6 className="ml-3">RCS</h6>
                          </div>
                          <div className="col-md-9 col-sm-12">
                            <div className="d-flex flex-wrap">
                              <div className="form-check mr-4">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="rcs-Deliver"
                                  checked={rcsType === "rcsDeliver"}
                                  onChange={handleRcsTypeChange}
                                  value="rcsDeliver"
                                />
                                <label className="form-check-label" htmlFor="rcs-Deliver">Deliver</label>
                              </div>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="rcs-submission"
                                  checked={rcsType === "rcsSubmission"}
                                  onChange={handleRcsTypeChange}
                                  value="rcsSubmission"
                                />
                                <label className="form-check-label" htmlFor="rcs-submission">Submission</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Agent Selection */}
                        <div className="row mb-3">
                          <div className="col-md-3 col-sm-12">
                            <h6 className="ml-3">Agent</h6>
                          </div>
                          <div className="col-md-9 col-sm-12">
                            <div className="d-flex flex-wrap">
                              <div className="form-check mr-4">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={agent === "peragent"}
                                  onChange={handleAgentTypeChange}
                                  value="peragent"
                                />
                                <label className="form-check-label">Per Agent</label>
                              </div>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={agent === "perconversation"}
                                  onChange={handleAgentTypeChange}
                                  value="perconversation"
                                />
                                <label className="form-check-label">Per Conversation</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Per Agent Inputs */}
                        {agent === "peragent" && (
                          <div className="row mb-3" style={{ padding: "10px" }}>
                            <div className="col-md-3 col-sm-6 mb-2">
                              <label><b>Allow Agent</b></label>
                              <select
                                value={selectAgent}
                                onChange={(e) => setSelectAgent(e.target.value)}
                                className="form-control"
                              >
                                <option value="">Select</option>
                                {Array.from({ length: 50 }, (_, i) => (
                                  <option key={i} value={i}>{i}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                              <label><b>Per Agent Cost</b></label>
                              <input
                                type="number"
                                className="form-control"
                                value={perAgentCost}
                                onChange={(e) => setPerAgentCost(e.target.value)}
                                placeholder="Per agent cost"
                              />
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                              <label><b>Conversation Limit</b></label>
                              <input
                                type="number"
                                className="form-control"
                                value={perConversationCost}
                                onChange={(e) => setPerConversationCost(e.target.value)}
                                placeholder="Conversation limit"
                              />
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                              <label><b>Exceed Price</b></label>
                              <input
                                type="text"
                                className="form-control"
                                value={exceedLimitCost}
                                onChange={(e) => setExceedLimitCost(e.target.value)}
                                placeholder="Exceed price"
                              />
                            </div>
                          </div>
                        )}

                        {/* Per Conversation Input */}
                        {agent === "perconversation" && (
                          <div className="row mb-3">
                            <div className="col-md-6 col-sm-12">
                              <label><b>Per Conversation Cost</b></label>
                              <input
                                type="number"
                                className="form-control"
                                value={perConversationCost}
                                onChange={(e) => setPerConversationCost(e.target.value)}
                                placeholder="Per conversation cost"
                              />
                            </div>
                          </div>
                        )}

                        {/* Auto Refund */}
                        <div className="row mb-3">
                          <div className="col-md-3 col-sm-12">
                            <h6 className="ml-3">Auto Refund</h6>
                          </div>
                          <div className="col-md-9 col-sm-12 d-flex flex-wrap">
                            <div className="form-check mr-4">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={refund === "yes"}
                                onChange={handleRefundChange}
                                value="yes"
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={refund === "no"}
                                onChange={handleRefundChange}
                                value="no"
                              />
                              <label className="form-check-label">No</label>
                            </div>
                          </div>
                        </div>

                        {/* DLT Scrubbing */}
                        <div className="row mb-3" style={{ padding: "10px" }}>
                          <div className="col-12">
                            <h6 className="ml-3">DLT Scrubbing Charge</h6>
                          </div>

                          <div className="col-md-2 col-sm-6 mb-2">
                            <label><b>SMS</b></label>
                            <input
                              type="number"
                              className="form-control"
                              name="sms"
                              value={dltScrubbingCharge.sms}
                              onChange={handleDltScrubbingChange}
                              placeholder="Enter SMS Price"
                            />
                          </div>

                          <div className="col-md-2 col-sm-6 mb-2">
                            <label><b>Whatsapp</b></label>
                            <input
                              type="number"
                              className="form-control"
                              name="whatsapp"
                              value={dltScrubbingCharge.whatsapp}
                              onChange={handleDltScrubbingChange}
                              placeholder="Enter Whatsapp Price"
                            />
                          </div>

                          <div className="col-md-2 col-sm-6 mb-2">
                            <label><b>RCS</b></label>
                            <input
                              type="number"
                              className="form-control"
                              name="rcs"
                              value={dltScrubbingCharge.rcs}
                              onChange={handleDltScrubbingChange}
                              placeholder="Enter RCS Price"
                            />
                          </div>

                          <div className="col-md-2 col-sm-6 mb-2">
                            <label><b>Email</b></label>
                            <input
                              type="number"
                              className="form-control"
                              name="email"
                              value={dltScrubbingCharge.email}
                              onChange={handleDltScrubbingChange}
                              placeholder="Enter Email Price"
                            />
                          </div>

                          <div className="col-md-2 col-sm-6 mb-2">
                            <label><b>Voice</b></label>
                            <input
                              type="number"
                              className="form-control"
                              name="voice"
                              value={dltScrubbingCharge.voice}
                              onChange={handleDltScrubbingChange}
                              placeholder="Enter Voice Price"
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12">
                            <button type="button" onClick={SubmitBillingMode} className="btn btn-primary m-3">
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </main>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default UserBillingMode;
